<div class="row no-gutters h-100">
  <!-- ===== Panel izquierdo: Envío de comandos ===== -->
  <div class="col-12 col-lg-3 panel-left">
    <div class="commands-panel p-3 d-flex flex-column">
      <h5 class="font-weight-bold mb-4">{{ "speed-config.commands" | translate }}</h5>

      <!-- Radio: Normal / Orbital -->
      <div class="d-flex mb-4" style="gap: 24px">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="speed_mode_config"
            id="sc_normal"
            value="normal"
            [ngModel]="dataMasive.view_mode_speed"
            (change)="changeInput('normal', 'view_mode_speed')"
            [checked]="dataMasive.view_mode_speed === 'normal'"
          />
          <label class="form-check-label" for="sc_normal">
            {{ "speed-config.normal" | translate }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="speed_mode_config"
            id="sc_orbital"
            value="orbital"
            [ngModel]="dataMasive.view_mode_speed"
            (change)="changeInput('orbital', 'view_mode_speed')"
            [checked]="dataMasive.view_mode_speed === 'orbital'"
          />
          <label class="form-check-label" for="sc_orbital">
            {{ "speed-config.orbital" | translate }}
          </label>
        </div>
      </div>

      <!-- Sliders -->
      <div class="sliders-section flex-fill">
        <ng-container *ngIf="isOrbital()">
          <div class="slider-group mb-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="slider-label mb-0">{{ "speed-config.high" | translate }}</label>
              <span class="slider-value">{{ dataMasive.status_high_speed }}%</span>
            </div>
            <input
              class="speed-range w-100"
              type="range"
              list="sc_list_high"
              max="100"
              min="37.5"
              step="12.5"
              [ngModel]="dataMasive.status_high_speed"
              [style.--track-fill]="getSliderPct(dataMasive.status_high_speed)"
              (change)="changeInput($event.target.value, 'status_high_speed')"
            />
            <datalist id="sc_list_high">
              <option *ngFor="let opt of optionSpeed" [value]="opt" [label]="opt + '%'"></option>
            </datalist>
          </div>

          <div class="slider-group mb-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="slider-label mb-0">{{ "speed-config.low" | translate }}</label>
              <span class="slider-value">{{ dataMasive.status_low_speed }}%</span>
            </div>
            <input
              class="speed-range w-100"
              type="range"
              list="sc_list_low"
              max="100"
              min="37.5"
              step="12.5"
              [ngModel]="dataMasive.status_low_speed"
              [style.--track-fill]="getSliderPct(dataMasive.status_low_speed)"
              (change)="changeInput($event.target.value, 'status_low_speed')"
            />
            <datalist id="sc_list_low">
              <option *ngFor="let opt of optionSpeed" [value]="opt" [label]="opt + '%'"></option>
            </datalist>
          </div>
        </ng-container>

        <ng-container *ngIf="!isOrbital()">
          <div class="slider-group mb-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="slider-label mb-0">{{ "speed-config.speed" | translate }}</label>
              <span class="slider-value">{{ dataMasive.status_speed }}%</span>
            </div>
            <input
              class="speed-range w-100"
              type="range"
              list="sc_list_speed"
              max="100"
              min="37.5"
              step="12.5"
              [ngModel]="dataMasive.status_speed"
              [style.--track-fill]="getSliderPct(dataMasive.status_speed)"
              (change)="changeInput($event.target.value, 'status_speed')"
            />
            <datalist id="sc_list_speed">
              <option *ngFor="let opt of optionSpeed" [value]="opt" [label]="opt + '%'"></option>
            </datalist>
          </div>
        </ng-container>
      </div>

      <!-- Botones -->
      <div class="commands-footer">
        <div style="width: 80%">
          <button
            type="button"
            class="btn btn-primary btn-block mb-2"
            [disabled]="isSendDisabled() || loadingAction !== null"
            (click)="send()"
          >
            <span
              *ngIf="loadingAction === 'send'"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
            >
              <span class="sr-only"></span>
            </span>
            {{ "speed-config.send" | translate }}
          </button>

          <div class="d-flex turn-row" style="gap: 8px" *ngIf="globalFunction.validateSoloAdmin()">
            <button
              type="button"
              class="btn btn-danger flex-fill"
              [disabled]="loadingAction !== null"
              (click)="turnOff()"
            >
              <span
                *ngIf="loadingAction === 'turnOff'"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
              >
                <span class="sr-only"></span>
              </span>
              {{ "speed-config.turn-off" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-success flex-fill"
              [disabled]="loadingAction !== null"
              (click)="turnOn()"
            >
              <span
                *ngIf="loadingAction === 'turnOn'"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
              >
                <span class="sr-only"></span>
              </span>
              {{ "speed-config.turn-on" | translate }}
            </button>
          </div>
        </div>
        <div style="width: 70%">
          <button
            type="button"
            class="btn btn-secondary btn-block mt-2"
            [disabled]="loadingAction !== null"
            (click)="requestStatus()"
          >
            <span
              *ngIf="loadingAction === 'requestStatus'"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
            >
              <span class="sr-only"></span>
            </span>
            {{ "speed-config.request-status" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== Panel derecho: Respuestas ===== -->
  <div class="col-12 col-lg-9">
    <div class="p-3 h-100 d-flex flex-column">
      <h5 class="font-weight-bold mb-3">{{ "speed-config.responses" | translate }}</h5>

      <!-- Filtros -->
      <div class="d-flex mb-3" style="gap: 8px">
        <input
          type="text"
          class="form-control"
          style="height: 35px!important"
          [(ngModel)]="filterName"
          [placeholder]="'speed-config.filter-name' | translate"
        />
        <select class="form-control" style="height: 35px!important" [(ngModel)]="filterStatus">
          <option value="">{{ "speed-config.filter-status" | translate }}</option>
          <option value="loading">{{ "speed-config.status-loading" | translate }}</option>
          <option value="done">{{ "speed-config.status-done" | translate }}</option>
          <option value="error">{{ "speed-config.status-error" | translate }}</option>
        </select>
      </div>

      <!-- Estado por alimentador -->
      <div class="responses-list flex-fill" style="max-height: 70vh">
        <ng-container *ngIf="feederStatuses.length > 0; else emptyResponses">
          <div *ngFor="let s of filteredStatuses()" class="response-item mb-2">
            <h6 class="mb-1 font-weight-bold">{{ s.name }}</h6>

            <div class="response-body border rounded p-2">
              <!-- Razón de error (visible antes de las tarjetas) -->
              <small *ngIf="s.status === 'error' && s.failReason" class="d-block text-danger text-center py-2 mb-2">
                {{ s.failReason }}
              </small>

              <!-- Detalle de datos (visible solo cuando done) -->
              <div *ngIf="s.status === 'done' && s.data" class="mb-2 pl-1">
                <!-- SPEED_RESPONSE / ORBITAL_SPEED -->
                <ng-container *ngIf="s.type === 'SPEED_RESPONSE' || s.type === 'ORBITAL_SPEED'">
                  <small
                    *ngIf="!s.data.orbital_enabled && !s.data.speed_enabled"
                    class="d-block text-muted"
                  >
                    {{ "speed-config-component.no-speed-assigned" | translate }}
                  </small>
                  <ng-container *ngIf="s.data.speed_enabled">
                    <small class="d-block font-petition">{{ "speed-config-component.normal-speed-on" | translate }}</small>
                    <small class="d-block text-muted">{{ "general.value" | translate }}: {{ s.data.speed }}</small>
                  </ng-container>
                  <ng-container *ngIf="s.data.orbital_enabled">
                    <small class="d-block font-petition">{{ "speed-config-component.orbital-speed-on" | translate }}</small>
                    <small class="d-block text-muted">{{ "speed-config.high" | translate }}: {{ s.data.high_speed }}</small>
                    <small class="d-block text-muted">{{ "speed-config.low" | translate }}: {{ s.data.low_speed }}</small>
                  </ng-container>
                </ng-container>
                <!-- SPEED_CONFIG -->
                <ng-container *ngIf="s.type === 'SPEED_CONFIG'">
                  <small class="d-block">
                    Velocidad: {{ s.data.speed_enabled ? "Encendida" : "Apagada" }}
                  </small>
                </ng-container>
              </div>

              <!-- Tarjetas de respuesta al fondo (estilo loader) -->
              <div class="center">
                <!-- Respuesta del servidor -->
                <div class="w-100" *ngIf="s.status === 'loading' || s.status === 'done'">
                  <div class="border border-success center p-1 mr-1">
                    <i class="fa fa-check-circle text-success mr-1" aria-hidden="true"></i>
                    <small>{{ "speed-config.server-response" | translate }}</small>
                  </div>
                </div>
                <div class="w-100" *ngIf="s.status === 'error'">
                  <div class="border border-danger center p-1 mr-1">
                    <i class="fa fa-times text-danger mr-1" aria-hidden="true"></i>
                    <small>{{ "speed-config.server-response" | translate }}</small>
                  </div>
                </div>

                <!-- Respuesta de velocidad -->
                <div class="w-100">
                  <div *ngIf="s.status === 'done'" class="border border-success center p-1">
                    <i class="fa fa-check-circle text-success mr-1" aria-hidden="true"></i>
                    <small>{{ "speed-config.speed-response" | translate }}</small>
                    <small *ngIf="s.time" class="text-muted ml-2">{{ s.time }}</small>
                  </div>
                  <div *ngIf="s.status === 'error'" class="border border-danger center p-1">
                    <i class="fa fa-times text-danger mr-1" aria-hidden="true"></i>
                    <small>{{ "speed-config.speed-response" | translate }}</small>
                  </div>
                  <div *ngIf="s.status === 'loading'" class="border border-warning center p-1">
                    <div
                      class="spinner-border text-warning mr-1"
                      role="status"
                      style="height: 13px; width: 13px"
                    >
                      <span class="sr-only"></span>
                    </div>
                    <small>{{ "speed-config.speed-response" | translate }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #emptyResponses> </ng-template>
      </div>
    </div>
  </div>
</div>
